var _path, _g, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeaderboardRank3(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 50,
    viewBox: "0 0 44 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.3103 12.4995V37.4995L21.6551 50L0 37.4995V12.4995L21.6551 0L43.3103 12.4995Z",
    fill: "url(#paint0_linear_3472_7686)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.2975 14.2395V35.7606L21.6565 46.5201L3.01562 35.7606V14.2395L21.6565 3.479L40.2975 14.2395Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8803 33.24C20.1843 33.24 18.7683 32.912 17.6323 32.256C16.5123 31.584 15.7363 30.608 15.3043 29.328L19.0963 27.696C19.1763 28.272 19.3203 28.736 19.5283 29.088C19.7523 29.424 20.0483 29.672 20.4163 29.832C20.7843 29.976 21.2163 30.048 21.7122 30.048C22.1603 30.048 22.5363 29.976 22.8403 29.832C23.1603 29.672 23.4083 29.448 23.5843 29.16C23.7603 28.872 23.8483 28.528 23.8483 28.128C23.8483 27.712 23.7603 27.376 23.5843 27.12C23.4243 26.864 23.1843 26.68 22.8643 26.568C22.5603 26.456 22.1843 26.4 21.7363 26.4C21.5283 26.4 21.3363 26.408 21.1603 26.424C20.9843 26.424 20.7843 26.44 20.5603 26.472V23.784C20.6883 23.8 20.8163 23.816 20.9443 23.832C21.0723 23.832 21.2243 23.832 21.4003 23.832C22.1523 23.832 22.6883 23.68 23.0083 23.376C23.3443 23.056 23.5123 22.56 23.5123 21.888C23.5123 21.312 23.3443 20.872 23.0083 20.568C22.6883 20.264 22.2323 20.112 21.6403 20.112C21.0163 20.112 20.5043 20.28 20.1043 20.616C19.7043 20.936 19.4483 21.488 19.3363 22.272L15.7123 21.024C15.8883 20.144 16.2643 19.4 16.8403 18.792C17.4163 18.184 18.1363 17.72 19.0003 17.4C19.8803 17.08 20.8483 16.92 21.9043 16.92C23.1203 16.92 24.1443 17.096 24.9763 17.448C25.8083 17.8 26.4403 18.304 26.8723 18.96C27.3043 19.616 27.5203 20.384 27.5203 21.264C27.5203 21.952 27.4083 22.528 27.1843 22.992C26.9763 23.456 26.7043 23.832 26.3683 24.12C26.0483 24.408 25.7203 24.624 25.3843 24.768C25.0483 24.896 24.7683 24.976 24.5443 25.008V25.08C24.8323 25.08 25.1603 25.136 25.5283 25.248C25.8963 25.36 26.2563 25.544 26.6083 25.8C26.9603 26.04 27.2483 26.376 27.4723 26.808C27.7123 27.24 27.8323 27.776 27.8323 28.416C27.8323 29.408 27.5683 30.264 27.0403 30.984C26.5283 31.704 25.8243 32.264 24.9283 32.664C24.0323 33.048 23.0163 33.24 21.8803 33.24Z",
    fill: "#231F20"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3472_7686",
    x1: 0,
    y1: 25,
    x2: 43.3103,
    y2: 25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98ADC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A2BBCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#B8D6E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#B3B4D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#AF9AC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#AC8ABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#AC85BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#A784BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#9A83B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#8482AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#6580A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#3E7E98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#367E96"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaderboardRank3);
export default __webpack_public_path__ + "static/media/Leaderboard_rank_3.3ad1fe32db3e04641ad857e358a03b12.svg";
export { ForwardRef as ReactComponent };